import * as Icons from '../Icons';

const iconsMap = {
  chatRoundDots: Icons.ChatRoundDots,
  smileCircleAdd: Icons.SmileCircleAdd,
  plainOutline: Icons.PlainOutline,
  checkCircle: Icons.CheckCircle,
  altArrowDown: Icons.AltArrowDown,
  arrowRight: Icons.ArrowRight,
  logo: Icons.Logo,
  home: Icons.Home,
  sun: Icons.Sun,
  moon: Icons.Moon,
  premiumInLogo: Icons.PremiumInLogo,
  scalesUnbalanced: Icons.ScalesUnbalanced,
  routing: Icons.Routing,
  questionCircle: Icons.QuestionCircle,
  norway: Icons.Norway,
  sweden: Icons.Sweden,
  heart: Icons.HeartEmoji,
  chevronRight: Icons.ChevronRight,
  appStore: Icons.AppStore,
  playMarket: Icons.PlayMarket,
  volleyball: Icons.Volleyball,
  emojiFunnyCircle: Icons.EmojiFunnyCircle,
  pallete: Icons.Pallete,
  microphone: Icons.Microphone,
  user: Icons.User,
  users: Icons.Users,
  callendarStar: Icons.CallendarStar,
  eye: Icons.Eye,
  graduationCap: Icons.GraduationCap,
  search: Icons.Search,
  finland: Icons.Finland,
  denmark: Icons.Denmark,
  shieldKeyhole: Icons.ShieldKeyhole,
  closeCircle: Icons.CloseCircle,
  documentAdd: Icons.DocumentAdd,
  chatSquareLike: Icons.ChatSquareLike,
  userCheck: Icons.UserCheck,
  penNewSquare: Icons.PenNewSquare,
  usersGroupTwoRounded: Icons.UsersGroupTwoRounded,
  moneyBagBusiness: Icons.MoneyBagBusiness,
  chatRoundLine: Icons.ChatRoundLine,
  dangerTriangle: Icons.DangerTriangle,
  fluentBot: Icons.FluentBot,
  ai: Icons.AI,
  letterUnreadBold: Icons.LetterUnreadBold,
  letter: Icons.Letter,
  closeCircleGradient: Icons.CloseCircleGradient,
  solarCheckCircle: Icons.SolarCheckCircle,
  appStoreContent: Icons.AppStoreContent,
  playMarketContent: Icons.PlayMarketContent,
  plus: Icons.Plus,
  school: Icons.School,
  mapPin: Icons.MapPin,
  bank: Icons.Bank,
  buildingSkyscraper: Icons.BuildingSkyscraper,
  bellRinging: Icons.BellRinging,
};

const sizes = {
  sm: 16,
  md: 20,
  lg: 24,
};

const Icon = ({ variant, size = 'md', ...props }) => {
  const SvgIcon = iconsMap[variant];
  const svgSize = sizes[size];

  if (!SvgIcon) {
    console.warn(`Icon "${variant}" not found.`);
    return null;
  }

  return <SvgIcon width={svgSize} height={svgSize} {...props} />;
};

export default Icon;
